var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-card-subtitle', {
    staticClass: "px-6"
  }, [_vm._v(" 상품을 선택하세요 ")]), _c('v-divider'), _c('table-receivers', _vm._b({
    attrs: {
      "readonly": "",
      "showsProducts": ""
    },
    model: {
      value: _vm.orders,
      callback: function callback($$v) {
        _vm.orders = $$v;
      },
      expression: "orders"
    }
  }, 'table-receivers', {
    form: _vm.form,
    isBulkOrder: _vm.isBulkOrder
  }, false)), _c('v-divider'), _c('v-card-actions', [_c('v-btn', _vm._b({
    attrs: {
      "x-large": "",
      "text": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.emit
    }
  }, 'v-btn', {
    disabled: _vm.disabled
  }, false), [_vm._v("입력완료")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }